import { createSelector } from "@ngrx/store";

export const getAvaliableLanguagesIsLoadingState = createSelector(
    (state: any) => state.i18n,
    (state: any) => state.getIn(['avaliableLanguages', 'isLoading'])
)

export const getAvaliableLanguagesState = createSelector(
    (state: any) => state.i18n,
    (state: any) => state.getIn(['avaliableLanguages', 'data'])
)

export const getDefaultTranslationsState = createSelector(
    (state: any) => state.i18n,
    (state: any) => state.getIn(['defaultTranslations', 'data'])
)

export const isContentEditableEnabled = createSelector(
    (state: any) => state.i18n,
    (state: any) => state.getIn(['contentEditable', 'isEnabled'])
)

export const getTranslationsList = createSelector(
    (state: any) => state.i18n,
    (state: any) => state.get('translationsList')
)